/**
 * A global namespace for mouse hover events.
 * @type {[string, string]}
 */
const mouseHoverEvents = ('onmouseleave' in document) ? ['mouseenter', 'mouseleave'] : ['mouseover', 'mouseout'];
export default mouseHoverEvents;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/strings/mouseHoverEvents.js
// module id = 10
// module chunks = 0